import { openSettingModal } from '../State/settingModal'

export default (id) => (dispatch) => {

  dispatch(openSettingModal({ id }))
  
}
